export default "__VITE_ASSET__v2RN5ZjI__"